import React from "react";
import pic from "../../../icons/summary.jpg";

class SummaryLeft extends React.Component {

    render() {
        return (
            <div className='word-wrap'>
                <h2>Site Summary</h2>
                <div style={{marginTop:'30px'}}>Please check all the details and confirm by clicking Order</div>
                <div className='left-pane-pic'>
                    <img src={pic} alt="Logo" />
                </div>
            </div>
        );
    }
}
export default SummaryLeft




// WEBPACK FOOTER //
// ./src/components/CreateSite/Step6/SummaryLeft.js